"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Tooltip_styles_1 = require("./Tooltip.styles");
var Content_1 = require("./Content");
var utils_1 = require("../utils");
var Tooltip = function (_a) {
    var _b = _a.showArrow, showArrow = _b === void 0 ? true : _b, _c = _a.direction, direction = _c === void 0 ? 'bottom' : _c, _d = _a.persist, persist = _d === void 0 ? false : _d, _e = _a.underline, underline = _e === void 0 ? false : _e, display = _a.display, content = _a.content, children = _a.children;
    var tooltipRef = react_1.useRef();
    var _f = react_1.useState(false), displayTooltip = _f[0], setDisplayTooltip = _f[1];
    var _g = react_1.useState(false), persistOnClick = _g[0], setPersistOnClick = _g[1];
    var _h = react_1.useState({}), position = _h[0], setPosition = _h[1];
    var tooltipSettings = __assign(__assign({}, Content_1.displayConfiguration), display);
    var showTooltip = function (e) {
        e.stopPropagation();
        setPosition(utils_1.calculatePosition(direction, tooltipRef.current.getBoundingClientRect(), tooltipSettings));
        setDisplayTooltip(true);
    };
    var hideTooltip = function (e) {
        e.stopPropagation();
        setDisplayTooltip(false);
    };
    var showPersistingTooltip = function (e) {
        e.stopPropagation();
        showTooltip(e);
        setPersistOnClick(function (prev) { return !prev; });
    };
    return (react_1.default.createElement(Tooltip_styles_1.Styles, { onMouseEnter: function (e) { return !(persist || persistOnClick) && showTooltip(e); }, onMouseLeave: function (e) { return !(persist || persistOnClick) && hideTooltip(e); }, onClick: showPersistingTooltip, underline: underline, ref: tooltipRef },
        displayTooltip && (react_1.default.createElement(Content_1.Content, __assign({}, tooltipSettings, position, { persist: persist, showArrow: showArrow, direction: direction, closeCallback: hideTooltip, render: content }))),
        children));
};
exports.default = Tooltip;
